export const CLIP_ART_TYPE = {
  CATEGORY: {
    id: 0,
    name: 'Category'
  },
  FAVORITE: {
    id: 1,
    name: 'Saved Favorites'
  },
  SEARCH: {
    id: 2,
    name: 'Search'
  }
};

export const CUSTOM_CLIP_ART_TYPE = -999;

export const SAVED_CLIP_ART_TYPE = {
  name: 'Saved Clip Art',
  id: CUSTOM_CLIP_ART_TYPE,
  value: CUSTOM_CLIP_ART_TYPE
};
